// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3hUhW","bigColWidth":"Table_bigColWidth__2-Oiq","biggerColWidth":"Table_biggerColWidth__3xC1g","row":"Table_row__2vcUE","col":"Table_col__1Tp0O"};